import type { PerkDefinition } from '@snake-royalle/shared';

/** 8 balanced perks — 2 per category */
export const PERK_POOL: PerkDefinition[] = [
  { id: 'gold_rush', name: 'Gold Rush', description: '+50% coin value, +1 chain window', category: 'ECONOMY', rarity: 1, modifiers: [] },
  { id: 'midas_touch', name: 'Midas Touch', description: '30% double coins, rare coins +50%', category: 'ECONOMY', rarity: 2, modifiers: [] },
  { id: 'predator', name: 'Predator', description: '+25% kill steal, +20 kill bonus', category: 'PVP', rarity: 2, modifiers: [] },
  { id: 'assassin', name: 'Assassin', description: '+30% victim drops, speed on kill', category: 'PVP', rarity: 2, modifiers: [] },
  { id: 'nitro', name: 'Nitro', description: '30% faster, longer spawn shield', category: 'MOVEMENT', rarity: 1, modifiers: [] },
  { id: 'ghost', name: 'Ghost', description: '15% faster, survive equal head-to-head', category: 'MOVEMENT', rarity: 2, modifiers: [] },
  { id: 'glass_cannon', name: 'Glass Cannon', description: '1.5x coins, lose coins near enemies', category: 'HIGH_RISK', rarity: 3, modifiers: [] },
  { id: 'all_in', name: 'All In', description: '2x coins, can\'t extract <200, chain +0.5x', category: 'HIGH_RISK', rarity: 3, modifiers: [] },
];

export function getRandomPerks(count: number = 3): PerkDefinition[] {
  const shuffled = [...PERK_POOL].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count);
}
